// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { updateDoc, doc, getFirestore } from "firebase/firestore";
import {browserLocalPersistence, browserSessionPersistence, getAuth, sendPasswordResetEmail, signInWithEmailAndPassword, signOut, updatePassword} from "firebase/auth"
import {getStorage, getDownloadURL, ref, uploadBytes} from "firebase/storage";
import { useEffect, useState } from "react";
//import JWT from "jsonwebtoken"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCcnunFsWwYNbI58u7jmV450ZBTrBPUtzo",
  authDomain: "knoesis-dante.firebaseapp.com",
  projectId: "knoesis-dante",
  storageBucket: "knoesis-dante.firebasestorage.app",
  messagingSenderId: "84264019333",
  appId: "1:84264019333:web:8d94ab1d78c28e8de350ec"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);


export const useAuthUser = () => {
const [user, setUser] = useState(undefined);
return {user, setUser};
}

export const signIn = (email,password) => {
    return signInWithEmailAndPassword(auth,email,password);
};

const storage = getStorage(app);
export const getStorageURL = (path) => getDownloadURL(ref(storage,path));

export const updateUserPassword = (newPassword) => updatePassword(auth.currentUser,newPassword);

export const resetPasswordEmail = (email) => {
  sendPasswordResetEmail(auth, email);
} 

export const uploadBytesToStorage = (url,file) => {
uploadBytes(ref(storage,url),file);
}

export const db = getFirestore(app,"knoesis-dante-uk");
export const isSignedIn = async (value) => {
    return await updateDoc(doc(db,"users",auth.currentUser.uid),{
              isSignedIn: value
            }).then(() => console.hidden("Updated signedIn " + value)).catch((reason) => console.error(reason));
        }

